import { useState } from "react";
import T from "../theme";
import { NAV } from "../data";

export default function Nav({ active, setSection }) {
  const [open, setOpen] = useState(false);

  function handleNav(n) {
    setSection(n);
    setOpen(false);
  }

  return (
    <nav
      style={{
        position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
        background: "rgba(4,13,26,0.88)", backdropFilter: "blur(20px)",
        borderBottom: `1px solid ${T.border}`,
        display: "flex", alignItems: "center", justifyContent: "space-between",
        padding: "0 40px", height: 64,
      }}
    >
      {/* Logo — computer icon */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
          {/* Monitor screen */}
          <rect x="3" y="4" width="22" height="15" rx="2" stroke={T.blue} strokeWidth="1.5" fill="none"/>
          {/* Screen inner glow */}
          <rect x="5" y="6" width="18" height="11" rx="1" fill={T.blueGlow2}/>
          {/* Code lines on screen */}
          <line x1="7" y1="9" x2="14" y2="9" stroke={T.blueLight} strokeWidth="1" strokeLinecap="round"/>
          <line x1="7" y1="11.5" x2="17" y2="11.5" stroke={T.blue} strokeWidth="1" strokeLinecap="round" opacity="0.7"/>
          <line x1="7" y1="14" x2="12" y2="14" stroke={T.blueLight} strokeWidth="1" strokeLinecap="round"/>
          {/* Stand neck */}
          <line x1="14" y1="19" x2="14" y2="22" stroke={T.blue} strokeWidth="1.5" strokeLinecap="round"/>
          {/* Stand base */}
          <line x1="9" y1="22" x2="19" y2="22" stroke={T.blue} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        <span style={{ color: T.white, fontFamily: T.mono, fontWeight: 700, fontSize: 13, letterSpacing: 3 }}>SCI-COM</span>
        <span style={{ color: T.blue, fontFamily: T.mono, fontSize: 9, letterSpacing: 2, marginLeft: -4 }}>2026</span>
      </div>

      {/* Nav links */}
      <div className={"nav-links" + (open ? " open" : "")}>
        {NAV.map((n) => (
          <button key={n} onClick={() => handleNav(n)}
            style={{
              background: active === n ? "rgba(59,130,246,0.15)" : "transparent",
              border: active === n ? "1px solid rgba(59,130,246,0.4)" : "1px solid transparent",
              color: active === n ? T.white : T.gray2,
              fontFamily: T.sans, fontSize: 12, fontWeight: 600,
              padding: "5px 13px", borderRadius: 20, cursor: "pointer",
              letterSpacing: 0.5, transition: "all 0.2s",
            }}
          >{n}</button>
        ))}
      </div>

      {/* Right side */}
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <button className="nav-cta"
          style={{
            background: "rgba(59,130,246,0.15)",
            border: `1px solid rgba(59,130,246,0.5)`,
            color: T.white,
            fontFamily: T.sans, fontWeight: 700, fontSize: 12, letterSpacing: 1,
            padding: "8px 20px", borderRadius: 20, cursor: "pointer",
          }}
        >Register / Check-in</button>

        <button className="nav-hamburger" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          <span style={{ transform: open ? "rotate(45deg) translate(5px,5px)" : "none" }} />
          <span style={{ opacity: open ? 0 : 1 }} />
          <span style={{ transform: open ? "rotate(-45deg) translate(5px,-5px)" : "none" }} />
        </button>
      </div>
    </nav>
  );
}
